import { useVModel } from '@vueuse/core';
export default defineComponent({
  name: 'BaseBottomSheet',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    showDragHandler: {
      type: Boolean,
      default: false
    },
    showHideBtn: {
      type: Boolean,
      default: false
    },
    hideBtnText: {
      type: String,
      default: 'Понятно'
    },
    prependIcon: {
      type: String,
      default: ''
    }
  },
  emits: ['click:prepend-icon'],
  setup: function setup(props) {
    var isActive = useVModel(props);
    return {
      isActive: isActive
    };
  }
});